import {Add} from 'components/grid-dx/consult-buttons';
import {Column} from 'devextreme-react/data-grid';
import React from 'react';
import IntegrityRoleGrid from '../../../../../components/UserRole';
import {i18n2} from '../../../../i18n/i18n';
import {useGetProfiles, useLoadProfSpacToProfCourse} from '../../hooks/index';
import {ADD_PROFILE} from '../../types';
import {useIsTablet} from 'components/hooks/useIsTablet';
import {
  useActionButtonStyles,
  getActionColumnWidth,
} from 'components/grid-dx/styles/actionButtonStyles';

const Buttons = ({data}: any) => {
  const profiles = useGetProfiles();
  const isTablet = useIsTablet();
  const styles = useActionButtonStyles();
  let hidden: boolean = false;
  if (profiles.length > 0) {
    hidden = profiles.find(
      (x: any) => x.iD_ProfileSpac === data.iD_ProfileSpac,
    );
  }
  if (hidden) return null;
  return (
    <div
      className={isTablet ? styles.tabletContainer : styles.compactContainer}>
      <Add row={data} type={ADD_PROFILE} />
    </div>
  );
};

const SelectProfilesGrid = (props: any) => {
  const loadProfiles = useLoadProfSpacToProfCourse();
  const isTablet = useIsTablet();

  return (
    <IntegrityRoleGrid
      dataSource={loadProfiles}
      allowExport={false}
      allowActions={false}
      allowIntegrity={false}
      shouldSaveFilters={true}
      width="600px"
      height="70vh"
      id={['iD_ProfileSpac']}>
      <Column
        caption={i18n2._('#ProfileSpac')}
        dataField="iD_ProfileSpac"
        visible={false}
      />
      <Column caption={i18n2._('Perfil Spac')} dataField="name_ProfSpac" />
      <Column caption={i18n2._('Nombre del SPAC')} dataField="name_Spac" />
      <Column
        caption=""
        cellComponent={(e: any) => <Buttons data={e.data.data} />}
        width={getActionColumnWidth(1, isTablet)}
        fixed
        alignment="right"
      />
    </IntegrityRoleGrid>
  );
};

export default SelectProfilesGrid;
